import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { UiModule } from 'src/app/ui/ui.module';
import { AuthGuardService as AuthGuard } from 'src/app/services/auth/auth-guard.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrdersComponent } from './orders/orders.component';
import { ProjectsComponent } from './projects/projects.component';
import { CustomersComponent } from './customers/customers.component';
import { CreateOrderComponent } from './orders/create-order/create-order.component';
import { OrderModule } from '../order/order.module';
import { BudgetsComponent } from './budgets/budgets.component';
import { BatchSummaryComponent } from './budgets/batch-budget-edit/batch-summary/batch-summary.component';


const routes: Routes = [
  {
    path: 'orders',
    component: OrdersComponent,
    canActivate: [AuthGuard],
    data: {  title: 'dashboard.menu.orders.pageTitle' }
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [AuthGuard],
    data: {  title: 'dashboard.menu.projects.pageTitle' }
  },
  {
    path: 'budgets',
    component: BudgetsComponent,
    canActivate: [AuthGuard],
    data: {  title: 'dashboard.menu.budgets.pageTitle' }
  },
  {
    path: 'customers',
    component: CustomersComponent,
    canActivate: [AuthGuard],
    data: {  title: 'dashboard.menu.customers.pageTitle' }
  }
];

@NgModule({
  declarations: [
    DashboardComponent,
    OrdersComponent,
    ProjectsComponent,
    CustomersComponent,
    CreateOrderComponent,
    BudgetsComponent,
    BatchSummaryComponent
  ],
  imports: [CommonModule, UiModule, NgbModule, RouterModule.forChild(routes), OrderModule],
})
export class DashboardModule {}
